import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { FEATURE_FLAG_NAMESPACE } from '../../types/features.js';

import { emptyFeaturesFallback, loadFeatureFlags } from './utils.js';
import { featuresContext } from './context.js';
import {
  FEATURE_FLAG_QUERY_KEY,
  FEATURE_FLAG_RETRY,
  FEATURE_FLAG_RETRY_DELAY,
  FEATURE_FLAG_STALE_TIME,
} from './constants.js';

export function Provider({ children }) {
  const { data, isError, isLoading } = useQuery({
    queryKey: [FEATURE_FLAG_QUERY_KEY],
    queryFn: () => loadFeatureFlags(FEATURE_FLAG_NAMESPACE),
    staleTime: FEATURE_FLAG_STALE_TIME,
    retry: FEATURE_FLAG_RETRY,
    retryDelay: FEATURE_FLAG_RETRY_DELAY,
    refetchOnWindowFocus: false,
    throwOnError: false, // override global setting as we don't want this to throw
  });

  if (isLoading) {
    return null;
  }

  let featuresData = data;

  // degrade to empty feature set if there's an error
  if (isError) {
    featuresData = emptyFeaturesFallback;
  }

  return (
    <featuresContext.Provider value={featuresData || emptyFeaturesFallback}>
      {children}
    </featuresContext.Provider>
  );
}
